module.exports = __webpack_public_path__ + "static/media/studentMainBg.231e0a3a.svg";